import { useEvent } from "../../../context/EventContext";

// Component to display the sponsor details of the selected event.
//  If the selected event does not have any sponsor details, it displays a message saying "No Sponsor Details found.".
const Sponsor = () => {
  const { selectedEvent } = useEvent();

  const sponsorDetailsArray =
    selectedEvent && selectedEvent[4] ? selectedEvent[4] : [];

//   console.log(sponsorDetailsArray);

  return (
    <div className="sponser-section-details">
      {sponsorDetailsArray.length === 0 && (
        <h1 style={{ paddingLeft: "300px" }}>No Sponsor Details found.</h1>
      )}
      {sponsorDetailsArray.map((sponsorDetails, index) => (
        <div key={index} className="sponsor-card">
          <img
            src={sponsorDetails.company_banner}
            alt="Sponsorship Company name"
            className="banner-img"
          />
          <img
            src={sponsorDetails.company_logo}
            alt="Sponsorship Company logo"
            className="logo-img"
          />
          <p>Company Name: {sponsorDetails.company_name}</p>
          <p>Sponsor Type: {sponsorDetails.sponsor_type}</p>
        </div>
      ))}
    </div>
  );
};

export default Sponsor;
